import { ORDER_BY_DIRECTION_ASC } from '@atlaskit/jql-ast';

export const FALLBACK_SORT_DIRECTION = ORDER_BY_DIRECTION_ASC;
